import type { Props as PaymentMethodIconProps } from '#src/components/paymentMethods/Icon/index.tsx';
import { PaymentMethodIcon } from '#src/components/paymentMethods/Icon/index.tsx';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';
import { faFiatCurrencySymbols } from '#src/lib/fiat.ts';

type Props = Pick<PaymentMethodIconProps, 'size'>;

export const FiatWalletIcon = ({ size }: Props) => {
  const { fiatCurrency } = useFiatBalance();
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-onBase-success)"
      color="var(--c-white)"
      icon={faFiatCurrencySymbols[fiatCurrency]}
    />
  );
};
